module.exports = __webpack_public_path__ + "static/media/hero.d991626e.jpg";